import React, { useState, useEffect, useContext, useRef } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import AccreditationInput from "../../AccreditationInput/AccreditationInput";
import { validateString } from "../../../utils/validateString";
import { apiRoutes } from "../../../utils/apiRoutes";
import {
  createData,
  updateData,
  updatePublicData,
  deleteData,
} from "../../../utils/methods";
import { fetchData } from "../../../utils/methods";
import { useNavigate } from "react-router-dom";
import Modal from "../Modal";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import { trimValues } from "../../../utils/trimValues";
import { useAlert } from "../../../utils/AlertContext";
import HistoryPanel from "../../HistoryPanel/HistoryPanel";
import EditModalShell from "./EditModalShell";
import RegisteredByLine from "./RegisteredByLine";
import ConfirmationModal from "./ConfirmationModal";
import useEnterKeySubmit from "../../../hooks/useEnterKeySubmit";
import { diffChangedFields } from "../../../utils/diffChangedFields";

// Build-time literal (unlike apiRoutes) so Terser can prove the History
// branch below is dead code on tiers other than Third — genuinely absent
// from the compiled bundle, not just unrendered. See AddPerson.jsx.
const TIER = process.env.REACT_APP_MODE;

const AddUser = ({
  onCloseClick,
  object,
  editing,
  handleAddData,
  handleUpdateData,
  handleDeleteData,
  showEventGroupField,
  predefinedEventGroup,
  eventId,
  loginUser,
}) => {
  const [userObject, setUserObject] = useState(
    object
      ? object
      : {
          ime: "",
          prezime: "",
          entitet: "",
          pozicija: "",
          broj_telefona: "",
          pozivni: "",
          email: "",
          grupa: "",
        },
  );
  console.log("userObject", userObject);
  const [errors, setErrors] = useState({});
  const [groups, setGroups] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGroups, setIsLoadingGroups] = useState(false);
  const navigate = useNavigate();
  const [newUser, setNewUser] = useState({ username: "", password: "" });
  const [isProfileModal, setIsProfileModal] = useState(false);
  const { showAlert } = useAlert();
  const [eventGroups, setEventGroups] = useState([]);

  useEffect(() => {
    if (predefinedEventGroup) {
      const { name, ...rest } = predefinedEventGroup;

      setUserObject((prev) => ({
        ...prev,
        dogadjajGrupa: {
          ...rest,
          naziv: name,
        },
      }));
    }
  }, [predefinedEventGroup]);

  useEffect(() => {
    const fetchGroups = async () => {
      console.log("Fetching groups for AddUser modal", showEventGroupField);
      try {
        setIsLoadingGroups(true);

        const result = await fetchData(
          apiRoutes.getGroups,
          showAlert,
          navigate,
          t,
        );
        if (!result) return;

        setGroups(result.data);
        console.log("Fetched groups:", result.data);
      } catch (err) {
        console.error("Error fetching groups:", err);
      } finally {
        setIsLoadingGroups(false);
      }
    };
    if (!loginUser) {
      fetchGroups();
    }
  }, []);

  useEffect(() => {
    if (!showEventGroupField) return;

    const fetchGroups = async () => {
      try {
        setIsLoadingGroups(true);
        const route = apiRoutes.getEventGroups.replace(":eventId", eventId);
        const result = await fetchData(route, showAlert, navigate, t);

        if (!result) return;

        const { data } = result;

        console.log("dohvatam podatke", data);

        const newGroups = Array.isArray(data) ? data : data?.data;
        setEventGroups((prev) => [...prev, ...newGroups]);
      } catch (err) {
        console.error("Error fetching groups:", err);
      } finally {
        setIsLoadingGroups(false);
      }
    };
    if (!loginUser) {
      fetchGroups();
    }
  }, [showEventGroupField]);

  const validateAllFields = () => {
    const fieldsToValidate = [
      "ime",
      "prezime",
      "email",
      ...(loginUser ? ["sifra"] : []),
    ];
    let hasError = false;
    let err = false;
    fieldsToValidate.forEach((field) => {
      const value = userObject[field];
      if (field === "email") {
        err = validateString(value, "e_mail");
      } else if (field === "sifra") {
        err = validateString(value, "password");
      }
      if (!value || err) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [field]: true,
        }));
        hasError = true;
      }
    });

    return !hasError;
  };

  const setInputValue = (key, value) => {
    setUserObject((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };

  const [existingUserPrompt, setExistingUserPrompt] = useState(null);

  // Shared tail of the create/reactivate flows — same event-group assignment,
  // parent-state update, and "here are the credentials" modal either way.
  const finishUserSaved = async (resultData, sendData, grupa) => {
    if (showEventGroupField) {
      const groupUserData = {
        dogadjajId: eventId,
        dogadjajGrupaId: userObject.dogadjajGrupa?.id,
        korisnikId: resultData.id,
      };

      await createData(
        apiRoutes.addEventGroupUser,
        groupUserData,
        showAlert,
        navigate,
        t,
      );
    }

    const updatedSendData = {
      ...sendData,
      grupa,
    };

    handleAddData(
      predefinedEventGroup
        ? {
            korisnik: {
              ...updatedSendData,
              id: resultData?.id,
            },
          }
        : { ...updatedSendData, id: resultData?.id },
    );

    setNewUser({
      id: resultData?.id,
      username: userObject.email,
      password: resultData?.sifra,
      ime: userObject.ime,
      prezime: userObject.prezime,
    });
    showAlert(t("SUCCESSFULLY_SAVED"), "success");
    setIsProfileModal(true);
  };

  const handleAddClick = async () => {
    setErrors();
    const isValid = validateAllFields();

    const telefon = String(userObject.pozivni + userObject.broj_telefona);
    const podaciZaSlanje = {
      ...userObject,
      telefon,
      grupaId: userObject.grupa?.id,
    };

    const grupa = podaciZaSlanje.grupa;
    delete podaciZaSlanje.grupa;
    delete podaciZaSlanje.broj_telefona;
    delete podaciZaSlanje.pozivni;
    delete podaciZaSlanje.dogadjajGrupa;

    if (!isValid) {
      console.log("Postoje greške u formi.");
      showAlert(t("ERROR_MISSING_REQUIRED_FIELDS"), "error");
      return;
    }

    setIsLoading(true);
    const sendData = trimValues(podaciZaSlanje);

    try {
      const result = await createData(
        apiRoutes.addUser,
        sendData,
        showAlert,
        navigate,
        t,
        (data) => {
          // Email belongs to an existing but non-active account (see
          // createKorisnik in korisnici.js) — offer reactivation instead of
          // just showing a dead-end conflict toast.
          if (data?.errorKey === "ERROR_USER_EXISTS_INACTIVE") {
            setExistingUserPrompt({ ...data.params, sendData, grupa });
            return true;
          }
          return false;
        },
      );
      if (!result) return;

      await finishUserSaved(result.data, sendData, grupa);
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReactivateClick = async () => {
    if (!existingUserPrompt) return;
    const { id, sendData, grupa } = existingUserPrompt;

    setIsLoading(true);
    try {
      const result = await updateData(
        apiRoutes.reactivateUser.replace(":userId", id),
        sendData,
        showAlert,
        navigate,
        t,
      );
      if (!result) return;

      await finishUserSaved(result.data, sendData, grupa);
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
    } finally {
      setIsLoading(false);
      setExistingUserPrompt(null);
    }
  };

  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);

  // Opened from an event's Users tab (showEventGroupField): the action here
  // must only remove the korisnik from this event's group, never delete the
  // korisnik account itself — same distinction as the row-level remove icon
  // in UsersPanel.jsx (apiRoutes.deleteEventGroupUser, POST-based route).
  const isEventScoped = showEventGroupField && !loginUser;

  const handleDeleteClick = async () => {
    setIsLoading(true);
    try {
      let result;
      if (isEventScoped) {
        result = await createData(
          apiRoutes.deleteEventGroupUser,
          {
            dogadjajGrupaId: userObject.dogadjajGrupa?.id,
            korisnikId: object.id,
          },
          showAlert,
          navigate,
          t,
        );
      } else {
        const route = apiRoutes.deleteUser.replace(":userId", object.id);
        result = await deleteData(route, null, showAlert, navigate, t);
      }
      if (!result) return;

      handleDeleteData?.(object.id);
      showAlert(
        t(isEventScoped ? "SUCCESSFULLY_SAVED" : "SUCCESSFULLY_DELETED"),
        "success",
      );
      onCloseClick();
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
    } finally {
      setIsLoading(false);
      setIsConfirmDeleteOpen(false);
    }
  };

  const handleSaveClick = async () => {
    setErrors({}); // nemoj setErrors()
    const isValid = validateAllFields();
    if (!isValid) {
      console.log("Postoje greške u formi.", errors);
      showAlert(t("ERROR_MISSING_REQUIRED_FIELDS"), "error");
      return;
    }

    const id = object?.id;
    const route = apiRoutes.updateUser.replace(":id", id);

    const telefon = String(
      (userObject.pozivni ?? "") + (userObject.broj_telefona ?? ""),
    );

    // 1) LOGIN USER: samo pošalji podatke (bez compare / old_user)
    if (loginUser) {
      const payload = {
        ...userObject,
        telefon,
      };

      delete payload.broj_telefona;
      delete payload.pozivni;
      delete payload.id;
      delete payload.old_user; // ako postoji slučajno

      const sendData = trimValues(payload);

      setIsLoading(true);
      try {
        const result = await updatePublicData(
          route,
          sendData,
          showAlert,
          navigate,
          t,
        );
        if (!result) return;

        handleUpdateData &&
          handleUpdateData({ ...sendData, id: result.data?.id });
        showAlert(t("SUCCESSFULLY_SAVED"), "success");
        onCloseClick();
      } catch (error) {
        console.error("API poziv nije uspeo:", error?.message);
      } finally {
        setIsLoading(false);
      }

      return;
    }

    // 2) NORMAL EDIT: radi compare sa old_user i šalji samo promene
    const podaciZaSlanje = {
      ...userObject,
      telefon,
      ...(userObject.grupa?.id !== userObject.old_user?.grupa?.id && {
        grupaId: userObject.grupa?.id,
      }),
    };

    delete podaciZaSlanje.broj_telefona;
    delete podaciZaSlanje.pozivni;
    delete podaciZaSlanje.id;

    const { grupaId, ...oldUserWithoutGrupaId } = userObject.old_user ?? {};
    const objekatPromena = diffChangedFields(podaciZaSlanje, oldUserWithoutGrupaId, ["old_user"]);

    const objekatSaGrupaId = { ...objekatPromena };
    if (objekatPromena?.grupa?.id) {
      objekatSaGrupaId.grupaId = objekatPromena.grupa.id;
      delete objekatSaGrupaId.grupa;
    }

    const sendData = trimValues(objekatSaGrupaId);

    setIsLoading(true);
    try {
      const result = await updateData(route, sendData, showAlert, navigate, t);
      if (!result) return;

      handleUpdateData({ ...sendData, id: result.data?.id });
      showAlert(t("SUCCESSFULLY_SAVED"), "success");
      onCloseClick();
    } catch (error) {
      console.error("API poziv nije uspeo:", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const { t } = useContext(TranslationsContext);

  useEnterKeySubmit(editing ? handleSaveClick : handleAddClick);

  console.log("user", userObject);
  console.log("predefinedEventGroup", predefinedEventGroup);

  return (
    <EditModalShell
      isLoading={isLoading}
      t={t}
      className="edit-modal-shell-side-top"
      headerInfo={
        editing && userObject?.korisnik ? (
          <RegisteredByLine korisnik={userObject.korisnik} t={t} />
        ) : (
          <p className="inria-sans-400 font-24 modal-title">
            {editing ? t("EDIT_USER_TITLE") : t("ADD_USER_TITLE")}
          </p>
        )
      }
      onSave={editing ? handleSaveClick : handleAddClick}
      onClose={onCloseClick}
      onDelete={
        editing && !loginUser ? () => setIsConfirmDeleteOpen(true) : undefined
      }
      deleteLabel={isEventScoped ? t("REMOVE_FROM_EVENT") : undefined}
      sidePanel={
        userObject && editing && TIER === "third" ? (
          <HistoryPanel tabela="korisnici" redId={object?.id} />
        ) : null
      }
    >
      <div className="flex-direction-column gap-24 width-100 modal-content">
              <div className="flex-direction-row gap-48 width-100 modal-two-inputs-inline">
                <AccreditationInput
                  label={t("NAME")}
                  className="modal-input"
                  setInputValue={(value) => setInputValue("ime", value)}
                  value={userObject.ime}
                  error={errors?.ime}
                  required
                />
                <AccreditationInput
                  label={t("SURNAME")}
                  className="modal-input"
                  setInputValue={(value) => setInputValue("prezime", value)}
                  value={userObject.prezime}
                  error={errors?.prezime}
                  required
                />
              </div>
              <div className="width-100">
                <AccreditationInput
                  className="modal-input"
                  label={t("ENTITY")}
                  setInputValue={(value) => setInputValue("entitet", value)}
                  value={userObject.entitet}
                />
              </div>
              <div className="width-100">
                <AccreditationInput
                  className="modal-input"
                  label={t("POSITION")}
                  setInputValue={(value) => setInputValue("pozicija", value)}
                  value={userObject.pozicija}
                />
              </div>
              <div className="flex-direction-row gap-48 width-100 modal-two-inputs-inline">
                <AccreditationInput
                  className="modal-input"
                  setPhone={(value) => setInputValue("broj_telefona", value)}
                  setCountry={(value) => setInputValue("pozivni", value)}
                  valuePhone={userObject.broj_telefona}
                  valueCode={userObject.pozivni}
                  type="phone"
                  required
                />
                <AccreditationInput
                  label={t("EMAIL")}
                  className="modal-input"
                  setInputValue={(value) => setInputValue("email", value)}
                  value={userObject.email}
                  error={errors?.email}
                  required
                />
              </div>
              <div className="width-100">
                {!isLoadingGroups && groups && groups.length > 0 && (
                  <AccreditationInput
                    type="dropdown"
                    searchable={true}
                    label={t("GROUP")}
                    className="modal-input"
                    selectedOption={userObject.grupa?.naziv || ""}
                    setSelectedOption={(selected_id) => {
                      const selectedGroup = groups.find(
                        (group) => group.id === selected_id,
                      );
                      if (selectedGroup) {
                        setInputValue("grupa", {
                          naziv: selectedGroup.naziv,
                          skracenica: selectedGroup.skracenica,
                          id: selectedGroup.id,
                        });
                      }
                    }}
                    options={groups?.map((group) => ({
                      value: group.naziv,
                      key: group.id,
                    }))}
                  />
                )}
              </div>
              {!isLoadingGroups && showEventGroupField && (
                <div className="width-100">
                  <AccreditationInput
                    type="dropdown"
                    className="modal-input"
                    label={t("EVENT_GROUP")}
                    selectedOption={userObject.dogadjajGrupa?.naziv || ""}
                    disabled={!!predefinedEventGroup}
                    options={
                      eventGroups?.flatMap((group) => {
                        const base = [{ value: group.naziv, key: group.id }];
                        const children =
                          group.children?.map((child) => ({
                            value: ` ${child.naziv}`,
                            key: child.id,
                          })) || [];
                        return [...base, ...children];
                      }) ?? []
                    }
                    setSelectedOption={(selected_id) => {
                      const selectedGroup = eventGroups.find(
                        (group) => group.id === selected_id,
                      );
                      if (selectedGroup) {
                        setInputValue("dogadjajGrupa", {
                          naziv: selectedGroup.naziv,
                          skracenica: selectedGroup.skracenica,
                          id: selectedGroup.id,
                        });
                      }
                    }}
                  />
                </div>
              )}

              {loginUser && (
                <>
                  <div className="flex-direction-column gap-8">
                    <AccreditationInput
                      placeholder="*********"
                      className={`change-password ${
                        errors.password ? "error" : ""
                      }`}
                      setInputValue={(value) => setInputValue("sifra", value)}
                      value={userObject.sifra}
                      label={t("PASSWORD")}
                      type="password"
                      autoComplete="password"
                      required
                      error={errors?.sifra}
                    />
                    {errors.sifra ? (
                      <p className="input-error-text">
                        {t("UI_PASSWORD_MUST_MEET_REQUIREMENTS")}
                      </p>
                    ) : null}
                  </div>
                  {/* <AccreditationInput
                    placeholder="*********"
                    className={`change-password ${
                      errors.confirm_password ? "error" : ""
                    }`}
                    setInputValue={(value) =>
                      setInputValue("confirm_password", value)
                    }
                    value={userObject.password}
                    label={t("PASSWORD")}
                    type="password"
                    autoComplete="confirm_password"
                  /> */}
                </>
              )}
      </div>
      {isProfileModal && (
        <Modal
          type="user-added"
          newUser={newUser}
          onCloseClick={() => {
            setIsProfileModal(false);
            onCloseClick();
          }}
        />
      )}
      {isConfirmDeleteOpen && (
        <ConfirmationModal
          handleDeclineClick={() => setIsConfirmDeleteOpen(false)}
          handleConfirmClick={() => handleDeleteClick()}
          term={`${userObject.ime} ${userObject.prezime}`}
          notification={
            isEventScoped
              ? "*" +
                t(
                  "USER_WILL_BE_REMOVED_FROM_EVENT_GROUP_BUT_REMAIN_IN_SYSTEM_GROUPS",
                )
              : undefined
          }
          warning={isEventScoped}
        />
      )}
      {existingUserPrompt && (
        <ConfirmationModal
          handleDeclineClick={() => setExistingUserPrompt(null)}
          handleConfirmClick={handleReactivateClick}
          question={t("REACTIVATE_USER_CONFIRM_QUESTION")}
          term={`${existingUserPrompt.ime} ${existingUserPrompt.prezime}`}
          notification={
            "*" +
            t("EXISTING_INACTIVE_USER_FOUND_DETAILS")
              .replace("{{ime}}", existingUserPrompt.ime || "")
              .replace("{{prezime}}", existingUserPrompt.prezime || "")
              .replace("{{telefon}}", existingUserPrompt.telefon || "")
              .replace("{{grupa}}", existingUserPrompt.grupa || "")
          }
          warning
        />
      )}
    </EditModalShell>
  );
};
export default AddUser;
